import { render, staticRenderFns } from "./PartnersSwiper.vue?vue&type=template&id=7e1cd026"
import script from "./PartnersSwiper.vue?vue&type=script&lang=js"
export * from "./PartnersSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports